import { WppButton, WppTypography } from '@platform-ui-kit/components-library-react'
import { useTranslation } from 'react-i18next'

import { Flex } from 'components/common/flex/Flex'
import { Modal } from 'components/surface/modal/Modal'
import { ConflictResolveEnum, FileItem } from 'types/files/files'
import { createNiceModal, NiceModalWrappedProps } from 'utils/createNiceModal'

interface Props extends NiceModalWrappedProps {
  items: FileItem[]
  onResolve: (resolveType: ConflictResolveEnum) => void
  onCancel: () => void
}

export const ResolveFileConflictModal = ({
  isOpen,
  id,
  onClose,
  onCloseComplete,
  items,
  onResolve,
  onCancel,
}: Props) => {
  const { t } = useTranslation()

  const onCancelClick = () => {
    onCancel()
    onClose()
  }
  const onSkipClick = () => {
    onResolve(ConflictResolveEnum.SKIP)
    onClose()
  }
  const onOverwriteClick = () => {
    onResolve(ConflictResolveEnum.REPLACE)
    onClose()
  }

  return (
    <Modal
      open={isOpen}
      onWppModalClose={onClose}
      onWppModalCloseComplete={onCloseComplete}
      disableOutsideClick
      data-testid={id}
    >
      <Flex slot="header" align="center" gap={9}>
        <WppTypography type="xl-heading">{t('os.files.conflict_modal.title')}</WppTypography>
      </Flex>

      <WppTypography slot="body" type="s-body">
        {t('os.files.conflict_modal.description', { count: items.length })}
      </WppTypography>

      <Flex slot="actions" justify="end" gap={12}>
        <WppButton variant="secondary" size="s" onClick={onCancelClick} data-testid="cancel-button">
          {t('os.common.cancel')}
        </WppButton>
        {items.length > 1 && (
          <WppButton size="s" data-testid="skip-button" onClick={onSkipClick}>
            {t('os.files.conflict_modal.skip_button')}
          </WppButton>
        )}
        <WppButton size="s" data-testid="overwrite-button" onClick={onOverwriteClick}>
          {t('os.files.conflict_modal.overwrite_button', { count: items.length })}
        </WppButton>
      </Flex>
    </Modal>
  )
}

export const { showModal: showResolveFileConflictModal } = createNiceModal(
  ResolveFileConflictModal,
  'resolve-file-conflict-modal',
)
